import { Chip } from '@fukku/chip'
import type { TransitionEvent } from 'react'
import { cx } from 'utils/cx'
import { sendFeedbackChatbotEvent } from '../../analytics/sendFeedbackChatbotEvent'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'
import type {
	QuickRepliesMessage,
	QuickRepliesMessageFeedback,
} from '../../types/messageTypes'
import { getHumanMessagesCount } from '../../utils/getHumanMessagesCount'
import styles from './FeedbackQuickReplies.module.scss'

export const FeedbackQuickReplies = ({
	message,
}: { readonly message: QuickRepliesMessage }) => {
	const {
		sendHumanMessage,
		deleteChoices,
		shouldFadeoutMessages,
		chatHistoryMessages,
	} = useChatBotMessages()

	const handleQuickReplyClick = (
		quickReplyText: string,
		feedback: QuickRepliesMessageFeedback
	) => {
		sendHumanMessage({ messageContent: quickReplyText })
		sendFeedbackChatbotEvent({
			id: getHumanMessagesCount(chatHistoryMessages),
			label: feedback,
		})
	}

	const onFeedbackQuickRepliesTransitionEnd = (
		e: TransitionEvent<HTMLDivElement>
	) => {
		if (e.propertyName === 'opacity') {
			deleteChoices()
		}
	}

	return (
		<div
			className={cx(
				styles.feedbackQuickReplies,
				shouldFadeoutMessages && styles.hidden
			)}
			onTransitionEnd={onFeedbackQuickRepliesTransitionEnd}
		>
			{message.elements.map((quickReply) => (
				<Chip
					name={quickReply.optionValue}
					key={quickReply.optionValue}
					handleClick={(quickReplyText) =>
						handleQuickReplyClick(quickReplyText, quickReply.feedback)
					}
				/>
			))}
		</div>
	)
}
